import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped module
import isInReviewOrBlocked from 'content-label-lib/utils/isInReviewOrBlocked';
// @ts-expect-error Untyped module
import WarningTag from 'content-label-lib/components/WarningTag';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { CONTENT_PLATFORM_PROPERTY_NAME, contentIsArchived, contentIsInViolation, contentIsPublishedWithScheduledUpdate, contentIsScheduled, contentIsScheduledToBeUnpublished, getContentPropertyValue, getContentStatusType, useAuthInfoProvider, useContentObjectType } from 'content-management-data-lib';
// @ts-expect-error Untyped module
import { getDateTime } from '../../utils/time';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ContentSecurityStates from '../../constants/ContentSecurityStates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getStatusTypeKey = (crmObject, statusType, isUngatedToUseResolvedStateProperty) => {
  if (contentIsInViolation(crmObject)) {
    const securityState = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.SECURITY_STATE);
    return `${securityState}.status`;
  }
  if (contentIsScheduledToBeUnpublished(crmObject, isUngatedToUseResolvedStateProperty)) {
    return 'publishedUntil';
  }
  if (contentIsPublishedWithScheduledUpdate(crmObject, isUngatedToUseResolvedStateProperty)) {
    return 'publishedWithScheduledUpdate';
  }
  if (contentIsArchived(crmObject)) {
    return 'archived';
  }
  return statusType;
};
const PublishStatusCell = ({
  crmObject,
  reviewData,
  overrideStatusTagUse,
  overrideStatusLabel
}) => {
  const {
    getIsUngatedToUseResolvedStateProperty
  } = useAuthInfoProvider();
  const isUngatedToUseResolvedStateProperty = getIsUngatedToUseResolvedStateProperty();
  const statusType = getContentStatusType(crmObject, isUngatedToUseResolvedStateProperty);
  const isArchived = contentIsArchived(crmObject);
  const isScheduled = contentIsScheduled(crmObject, isUngatedToUseResolvedStateProperty);
  const isScheduledToBeUnpublished = contentIsScheduledToBeUnpublished(crmObject, isUngatedToUseResolvedStateProperty);
  const contentId = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.ID);
  const scheduledPublishDate = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_PUBLISH_DATE);
  const scheduledUnpublishDate = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_UNPUBLISH_DATE);
  const securityState = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.SECURITY_STATE);
  const {
    contentObjectType
  } = useContentObjectType();
  const isInViolation = contentIsInViolation(crmObject);
  const statusTypeKey = getStatusTypeKey(crmObject, statusType, isUngatedToUseResolvedStateProperty);
  return isInReviewOrBlocked(contentId, reviewData) ? /*#__PURE__*/_jsx(WarningTag, {
    contentId: contentId,
    contentReviewData: reviewData,
    keyWord: "webpage",
    withBulkData: true
  }) : /*#__PURE__*/_jsxs(StatusTag, {
    use: overrideStatusTagUse || statusType,
    hollow: isArchived,
    inline: true,
    "aria-label": statusTypeKey,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      "aria-hidden": true,
      "data-test-id": `content-status-${isInViolation ? securityState : statusTypeKey}`,
      message: overrideStatusLabel || `content-management-listing-lib.table.cells.publishStatus.${statusTypeKey}`,
      options: {
        scheduledPublishDate: isScheduled && scheduledPublishDate ? getDateTime(scheduledPublishDate, false) : undefined,
        scheduledUnpublishDate: isScheduledToBeUnpublished && scheduledUnpublishDate ? getDateTime(scheduledUnpublishDate, false) : undefined
      }
    }), isInViolation ? /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `content-management-listing-lib.table.cells.publishStatus.tooltip.${contentObjectType}`
      }),
      tooltipPlacement: "bottom",
      tooltipProps: {
        use: securityState === ContentSecurityStates.SECURITY_VIOLATION ? 'longform' : 'default'
      },
      marginInlineStart: "100"
    }) : null]
  });
};
export default PublishStatusCell;